import { z } from "zod";

export const UserId_Schema = z.number().int().positive();
